import { useState } from "react";
import { trpc } from "../../../utils/trpc";
import { LoadingThrobber } from "../base_components/loading_throbber";
import { SeshPrimaryButton } from "../base_components/sesh_primary_button";
import { SeshTextInput } from "../base_components/sesh_text_input";
import { SeshWarningButton } from "../base_components/sesh_warning_button";

export function AdminStatusPage(props: {}) {
	const status_message_query = trpc.misc.getStatusMessage.useQuery(
		undefined,
		{
			onSuccess: (data) => setInput(data),
		}
	);

	const context = trpc.useContext();

	const status_message_mutation = trpc.admin.setStatusMessage.useMutation({
		onSuccess: () => {
			context.misc.getStatusMessage.invalidate();
		},
	});

	const [input, setInput] = useState(status_message_query?.data ?? "");

	if (!status_message_query.isSuccess) {
		return <LoadingThrobber />;
	}

	return (
		<div className="flex flex-col">
			<SeshTextInput
				label="Status Message"
				input_props={{
					value: input,
					onChange: (data) => setInput(data.currentTarget.value),
					disabled: status_message_mutation.isLoading,
				}}
			/>
			<div className="ml-auto flex gap-2">
				<SeshPrimaryButton
					className="w-fit"
					onClick={() =>
						status_message_mutation.mutate({
							status_message: input,
						})
					}
					is_loading={status_message_mutation.isLoading}
				>
					Save
				</SeshPrimaryButton>
				<SeshWarningButton
					className="w-fit"
					onClick={() =>
						status_message_mutation.mutate({
							status_message: "",
						})
					}
					is_loading={status_message_mutation.isLoading}
				>
					Clear
				</SeshWarningButton>
			</div>
		</div>
	);
}
